// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-ModulableTree-___ModulableTree-module__itemContainer {
  display: flex;
  flex-direction: column;
}

.app-components-ModulableTree-___ModulableTree-module__headerContainer {
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
}

.app-components-ModulableTree-___ModulableTree-module__title {
  font-size: 18px;
  font-weight: bold;
}

.app-components-ModulableTree-___ModulableTree-module__item {
  border-top: var(--mainBorder);
  min-height: 35px;
  max-height: 100%;
  height: inherit;
}

.app-components-ModulableTree-___ModulableTree-module__item:hover {
  box-shadow: 0 0 1000px rgba(0, 0, 0, 0.04) inset;
}

.app-components-ModulableTree-___ModulableTree-module__itemsContainer {
  border: var(--mainBorder);
  border-top: none;
  position: relative;
}

.app-components-ModulableTree-___ModulableTree-module__itemContentWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  padding-left: 10px;
  height: 100%;
  min-height: 35px;
  height: inherit;
  max-height: 100%;
}

.app-components-ModulableTree-___ModulableTree-module__labelContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  height: 100%;
  min-height: 35px;
  height: inherit;
}

.app-components-ModulableTree-___ModulableTree-module__actionsContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 35px;
  height: inherit;
}

.app-components-ModulableTree-___ModulableTree-module__expandIcon {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 10px 10px 10px 0px;
  cursor: pointer;
  pointer-events: all;
  color: grey;
  height: inherit;
}

.app-components-ModulableTree-___ModulableTree-module__icon {
  height: 100%;
  min-height: 35px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding-right: 10px;
}

.app-components-ModulableTree-___ModulableTree-module__draggableIcon {
  color: grey;
  padding: 0 5px 0 15px;
  min-width: 15px;
}

.app-components-ModulableTree-___ModulableTree-module__isDropOver {
  background-color: lightgrey;
}

.app-components-ModulableTree-___ModulableTree-module__menuIconContainer {
  padding: 0 10px;
  flex: 0;
  cursor: pointer;
  height: 100%;
  min-height: 35px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.app-components-ModulableTree-___ModulableTree-module__actionsIcon:hover {
  color: black;
}

.app-components-ModulableTree-___ModulableTree-module__actionsMenuIcon {
  height: 100%;
  margin-right: 10px;
}

.app-components-ModulableTree-___ModulableTree-module__actionsLabelIcon {
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.app-components-ModulableTree-___ModulableTree-module__actionsMenuIcon {
  pointer-events: auto;
  height: 100%;
}

.app-components-ModulableTree-___ModulableTree-module__actionsIconsContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  height: 100%;
}

.app-components-ModulableTree-___ModulableTree-module__actionsLabelContainer {
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}

.app-components-ModulableTree-___ModulableTree-module__actionsIconContainer {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 4px;
  cursor: pointer;
  margin: 3px;
  color: var(--colors-black);
}

.app-components-ModulableTree-___ModulableTree-module__actionsIconContainer:hover {
  transition: 100ms;
  color: #e5e5e5;
  background-color: var(--colors-black);
}
`, "",{"version":3,"sources":["webpack://./app/components/ModulableTree/ModulableTree.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,OAAO;EACP,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC","sourcesContent":[".itemContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.headerContainer {\n  padding: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.item {\n  border-top: var(--mainBorder);\n  min-height: 35px;\n  max-height: 100%;\n  height: inherit;\n}\n\n.item:hover {\n  box-shadow: 0 0 1000px rgba(0, 0, 0, 0.04) inset;\n}\n\n.itemsContainer {\n  border: var(--mainBorder);\n  border-top: none;\n  position: relative;\n}\n\n.itemContentWrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding-left: 10px;\n  height: 100%;\n  min-height: 35px;\n  height: inherit;\n  max-height: 100%;\n}\n\n.labelContent {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  height: 100%;\n  min-height: 35px;\n  height: inherit;\n}\n\n.actionsContent {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  min-height: 35px;\n  height: inherit;\n}\n\n.expandIcon {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  margin: 10px 10px 10px 0px;\n  cursor: pointer;\n  pointer-events: all;\n  color: grey;\n  height: inherit;\n}\n\n.icon {\n  height: 100%;\n  min-height: 35px;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  padding-right: 10px;\n}\n\n.draggableIcon {\n  color: grey;\n  padding: 0 5px 0 15px;\n  min-width: 15px;\n}\n\n.isDropOver {\n  background-color: lightgrey;\n}\n\n.menuIconContainer {\n  padding: 0 10px;\n  flex: 0;\n  cursor: pointer;\n  height: 100%;\n  min-height: 35px;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n\n.actionsIcon:hover {\n  color: black;\n}\n\n.actionsMenuIcon {\n  height: 100%;\n  margin-right: 10px;\n}\n\n.actionsLabelIcon {\n  height: 100%;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.actionsMenuIcon {\n  pointer-events: auto;\n  height: 100%;\n}\n\n.actionsIconsContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.actionsLabelContainer {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n}\n\n.actionsIconContainer {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 3px;\n  color: var(--colors-black);\n}\n\n.actionsIconContainer:hover {\n  transition: 100ms;\n  color: #e5e5e5;\n  background-color: var(--colors-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemContainer": `app-components-ModulableTree-___ModulableTree-module__itemContainer`,
	"headerContainer": `app-components-ModulableTree-___ModulableTree-module__headerContainer`,
	"title": `app-components-ModulableTree-___ModulableTree-module__title`,
	"item": `app-components-ModulableTree-___ModulableTree-module__item`,
	"itemsContainer": `app-components-ModulableTree-___ModulableTree-module__itemsContainer`,
	"itemContentWrapper": `app-components-ModulableTree-___ModulableTree-module__itemContentWrapper`,
	"labelContent": `app-components-ModulableTree-___ModulableTree-module__labelContent`,
	"actionsContent": `app-components-ModulableTree-___ModulableTree-module__actionsContent`,
	"expandIcon": `app-components-ModulableTree-___ModulableTree-module__expandIcon`,
	"icon": `app-components-ModulableTree-___ModulableTree-module__icon`,
	"draggableIcon": `app-components-ModulableTree-___ModulableTree-module__draggableIcon`,
	"isDropOver": `app-components-ModulableTree-___ModulableTree-module__isDropOver`,
	"menuIconContainer": `app-components-ModulableTree-___ModulableTree-module__menuIconContainer`,
	"actionsIcon": `app-components-ModulableTree-___ModulableTree-module__actionsIcon`,
	"actionsMenuIcon": `app-components-ModulableTree-___ModulableTree-module__actionsMenuIcon`,
	"actionsLabelIcon": `app-components-ModulableTree-___ModulableTree-module__actionsLabelIcon`,
	"actionsIconsContainer": `app-components-ModulableTree-___ModulableTree-module__actionsIconsContainer`,
	"actionsLabelContainer": `app-components-ModulableTree-___ModulableTree-module__actionsLabelContainer`,
	"actionsIconContainer": `app-components-ModulableTree-___ModulableTree-module__actionsIconContainer`
};
export default ___CSS_LOADER_EXPORT___;
